import { HttpHandler } from '@/common/http/HttpHandler';
import IUserContextService from './interfaces/IUserContextService';
import { UserContext } from '@/common/models';
import { AppStoreModule } from '@/store';
import {UserInfo as AzureADUserInfo} from 'adal-angular';

export class UserContextService implements IUserContextService {
  private httpHandler: HttpHandler;

  constructor(httpHandler: any) {
    this.httpHandler = httpHandler;
  }
  async getCurrentContext(authenticatedUser: AzureADUserInfo): Promise<UserContext> {
    try {
      const userContext: UserContext = new UserContext();
      if (authenticatedUser) {
        userContext.email = authenticatedUser.userName;
        userContext.name = authenticatedUser.profile.name;
        userContext.hasLoggedIn = true;
      }
      AppStoreModule.saveCurrentContext(userContext);
      return Promise.resolve(userContext);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
